module.exports = __webpack_public_path__ + "img/bell3.fc0a633a.svg";